<section class="fdb-block fp-active mt-5 grey lighten-5" [class.py-5]="!(isMobile | async)"
  data-block-type="call_to_action" data-id="1" draggable="true">
  <div class="container align-items-center justify-content-center" [class.d-flex]="!(isMobile | async)">
    <div class="row align-items-center text-left">
      <div class="col-12 col-sm-6">
        <img class="img-fluid shadow-lg rounded" src="../../../assets/IREB_web2.jpg" alt="IREB Building">
      </div>

      <div class="col-12 col-lg-5 ml-auto mr-auto pt-5 pt-lg-0">
        <h2 class="mb-4">UNT Health Fort Worth Faculty Profile System</h2>
        <p class="lead d-block">UNT Health Fort Worth is one of the nation’s premier graduate academic medical
          centers, with
          six schools that
          specialize in patient-centered education, research and health care.</p>
        <p class="mt-4" [ngClass]="{ 'd-flex-justify-center' : isMobile | async }">
          <button type="button" class="btn btn-secondary" [class.btn-lg]="isMobile | async"
            routerLink="/directory">Search Profiles</button>
          <button type="button" class="btn btn-primary ml-3" [class.btn-lg]="isMobile | async"
            (click)="showToast = true" [disabled]="showToast">Help</button>
        </p>
      </div>
    </div>
  </div>
</section>

<ngb-toast *ngIf="showToast" header="Faculty Profile Help" [autohide]="false"
  (hide)="close()" class="shadow-lg">
  <p>
    Information for the Faculty Profile is pulled from UNT Health Fort Worth Interfolio Faculty 180. Faculty are strongly
    encouraged to keep
    their UNT Health Fort Worth Interfolio Faculty 180 data up to date. More information on how to update your faculty profile in UNT Health Fort Worth
    Interfolio
    can be found at <a href="https://www.unthsc.edu/academic-affairs/faculty-affairs/hsc-interfolio/"
      target="_blank">https://www.unthsc.edu/academic-affairs/faculty-affairs/hsc-interfolio/</a>.
  </p>
</ngb-toast>